import React from "react";
import {
  Transition,
  Container,
  Segment,
  Header,
  Button
} from "semantic-ui-react";
import moment from "moment";

class ListadoCobros extends React.Component {
  state = { visible: false };

  componentDidMount() {
    this.setState(state => ({ visible: true }));
  }

  handleVolver = () => this.props.history.goBack();

  render() {
    return (
      <Transition.Group animation="scale" duration={250}>
        {this.state.visible && (
          <Container textAlign="center">
            <Segment>
              <Button
                content="Cerrar"
                floated="right"
                color="pink"
                icon="cancel"
                onClick={this.handleVolver}
              />
              <Header>
                Histórico de Cobros - {moment().format("DD/MM/YYYY")}
              </Header>
            </Segment>
            <Segment />
          </Container>
        )}
      </Transition.Group>
    );
  }
}
export default ListadoCobros;



// WEBPACK FOOTER //
// ./src/pages/listados/HistoricoCobros.jsx